import { b as getUserCount, c as getTrustPilotInfo } from "../../../../chunks/utils.js";
const load = async () => {
  const userCount = await getUserCount();
  const trustPilotInfo = await getTrustPilotInfo();
  return {
    userCount,
    trustPilotInfo
  };
};
export {
  load
};
